import type {
  AddNewTaskRequest,
  CreateNewProjectRequest,
} from '../api/schedulingApis';
import type { LinkSnapshot } from '../stores/types';

const STORAGE_PREFIX = 'falcon-planner:gantt-session-snapshot:';

export type GanttSessionSnapshot = {
  version: 1;
  affectedTaskIds: string[];
  editedTaskIds: string[];
  editedTaskFields: Record<string, string[]>;
  affectedRemovedLinkIds: Array<number | string>;
  affectedAddedLinkIds: Array<number | string>;
  pendingDependencyCreates: LinkSnapshot[];
  pendingDependencyDeletes: string[];
  pendingCreates: Record<string, AddNewTaskRequest>;
  pendingDeletes: string[];
  pendingProjectCreate: CreateNewProjectRequest | null;
  sessionStartTime: number | null;
  lastChangeTime: number | null;
};

function storageKey(projectId: string): string {
  return `${STORAGE_PREFIX}${projectId}`;
}

export function saveGanttSessionSnapshot(
  projectId: string,
  snapshot: GanttSessionSnapshot,
): void {
  if (!projectId || typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(storageKey(projectId), JSON.stringify(snapshot));
  } catch {
    // ignore quota / private mode
  }
}

export function loadGanttSessionSnapshot(projectId: string): GanttSessionSnapshot | null {
  if (!projectId || typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(storageKey(projectId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GanttSessionSnapshot;
    if (!parsed || parsed.version !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearGanttSessionSnapshot(projectId: string): void {
  if (!projectId || typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(storageKey(projectId));
  } catch {
    // ignore
  }
}
